export default __webpack_public_path__ + "static/media/order-pending.7ac54222.svg";